import { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import GenerateFinalExamQuestionsForm from "../Forms/GenerateFinalExamQuestionsForm";
import CopyExamVariantForm from "../Forms/CopyExamVariantForm";
import { FormattedMessage } from "react-intl";
import { Tab, Tabs, Box } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { GetClassByClassId } from "../../actions/teacherQueries";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";

export default function GenerateQuestionsModal(props) {
  const [option, setOption] = useState("create");

  const classData = GetClassByClassId(props.classId);

  const handleTabChange = (event, newValue) => {
    setOption(newValue);
  };

  const getStudentCourseModules = () => {
    if (props.course) {
      let data = props.studentCoursesModules.filter(
        (sc) => sc.id === props.course.id
      );

      if (!data) return null;

      let studentModules = data[0].modules.filter(
        (module) => module.qApiId != null
      );
      return studentModules;
    }
    return null;
  };

  if (classData.isLoading) {
    return <Pacmanloader />;
  }

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      modalClassName="custom-modal"
    >
      <ModalHeader toggle={props.toggle}>
        <div className="ms-2">
          <FormattedMessage id="GenerateQuestions" /> -{" "}
          {props.course ? props.course.courseName || props.course.name : ""}
        </div>
      </ModalHeader>
      <Tabs
        value={option}
        onChange={handleTabChange}
        indicatorColor="white"
        variant="fullWidth"
      >
        <Tab
          label={<FormattedMessage id="CreateNew" />}
          value="create"
          className={
            option === "create"
              ? "final-exam-tabs--Selected"
              : "final-exam-tabs--UnSelected"
          }
          icon={<CreateIcon fontSize="small" />}
          iconPosition="start"
        />
        <Tab
          label={<FormattedMessage id="CopyExam" />}
          value="copy"
          className={
            option === "copy"
              ? "final-exam-tabs--Selected"
              : "final-exam-tabs--UnSelected"
          }
          icon={<ContentCopyIcon fontSize="small" />}
          iconPosition="start"
        />
      </Tabs>

      <Box sx={{ width: 550, p: 2, borderTop: "0.5px solid #3ba8d8" }}>
        <ModalBody>
          {option === "create" ? (
            <GenerateFinalExamQuestionsForm
              classId={props.classId}
              classStudents={classData.data.students}
              student={props.student}
              dismissModal={props.toggle}
              course={props.course}
              studentCourseModules={
                props.level === "Student" ? getStudentCourseModules() : []
              }
              level={props.level}
            />
          ) : (
            <CopyExamVariantForm
              classId={props.classId}
              classStudents={classData.data.students}
              student={props.student}
              dismissModal={props.toggle}
              course={props.course}
              otherClasses={props.classes.filter((c) => c.id !== props.classId)}
              level={props.level}
            />
          )}
        </ModalBody>
      </Box>
    </Modal>
  );
}
